import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(marketing)/study-materials/page.tsx");
